import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import AppRoutes from "./routes";
import PixelTracker from "./components/common/PixelTracker";

function App() {
  return (
    <BrowserRouter>
      <PixelTracker />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
